<div *dvlibRequirePermission="{oneOf: ['module:work_time_controlling', 'module:personalplanung']}"
     class="title normal-abstand-top">
    <h2>{{ 'MANDANT.CONFIG.TITLE' | transloco }}</h2>
</div>
<select *dvlibRequirePermission="'module:work_time_controlling'"
        class="form-control"
        [name]="'defaultWorkTimeModel'"
        [(ngModel)]="mandantConfig().defaultWorkTimeModelId"
        (ngModelChange)="updateConfig(mandantConfig())"
        [tooltip]="'WORK_TIME_CONTROLLING.WORK_TIME_MODEL.DEFAULT' | transloco"
        [attr.aria-label]="'WORK_TIME_CONTROLLING.WORK_TIME_MODEL.DEFAULT' | transloco"
        dvlibRequireRole="ADMIN">
    <option [ngValue]="null">{{ 'WORK_TIME_CONTROLLING.WORK_TIME_MODEL.NO_DEFAULT' | transloco }}</option>
    @for (model of mandantConfig().workTimeModels; track model.id) {
        <option [ngValue]="model.id">{{ model | workTimeModelDisplayName }}</option>
    }
</select>
<select *dvlibRequirePermission="'module:personalplanung'"
        class="form-control"
        [name]="'defaultTerminType'"
        [(ngModel)]="mandantConfig().defaultTerminTypeId"
        (ngModelChange)="updateConfig(mandantConfig())"
        [tooltip]="'PERSONAL.TERMIN.TYPE.DEFAULT' | transloco"
        [attr.aria-label]="'PERSONAL.TERMIN.TYPE.DEFAULT' | transloco"
        dvlibRequireRole="ADMIN">
    <option [ngValue]="null">{{ 'PERSONAL.TERMIN.TYPE.NO_DEFAULT' | transloco }}</option>
    @for (type of mandantConfig().terminTypes; track type.id) {
        <option [ngValue]="type.id">{{ type.name }}</option>
    }
</select>
